import { QueryClient } from 'react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      refetchOnWindowFocus: false,
      onError: (error) => {
        console.log(error, "error");
      },
    },
  },
});

export default queryClient;
